<template>
  <multi-selection-tool-button
    icon="mdi-playlist-edit"
    :selected="selected"
    :disabled="
      disabled ||
        (nrObjectsSelected && nrObjectsSelected === 0) ||
        !canUseTool('store')
    "
    :tooltip="$t('EditSelected')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";
import { multiSelectionToolsMixin } from "@/mixins/forms/multipleObjectsSelection/multiSelectionToolsMixin";

export default {
  name: "HomeFormTableEditSelectedTool",

  components: { MultiSelectionToolButton },

  mixins: [multiSelectionToolsMixin],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    selected: {
      type: Boolean,
      default: false
    },

    nrObjectsSelected: {
      type: Number
    },

    permission: {
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/EditSelected.vue